<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container fluid>
      <v-row>
        <!-- //api-2 -->
        <v-col class="d-flex" cols="12" sm="6">
          <v-autocomplete :items="tclist" label="Tenant" v-model="selected_tenant" :loading="fetch_org_load"
            @change="fetchorganization()" rounded dense outlined></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="10" sm="6" id="orgdiv">
          <v-autocomplete :items="orglist" label="Organization" v-model="selected_org" :loading="check_admin_load"
            @change="getUsers()" rounded dense outlined></v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6">
          <v-autocomplete :items="users_list" label="User" item-text="username" item-value="id" v-model="selected_user"
            rounded dense outlined></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="functionality_name" label="Please Enter Functionality Name"
            hint="bypass,change password.." rounded dense outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center"> <v-btn color="primary" @click="save()">Save</v-btn></v-row>
    </v-container>
    <template>
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Access Control </strong>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field v-model="search" background-color="white" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-toolbar>
      </v-card>

      <v-card>
        <v-data-table :headers="headers" :items="bookList1" :search="search" @current-items="getFiltered">
          <template v-slot:top class="pb-5">
            <v-row dense justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-btn color="warning" icon dark @click="deleteAC(item)">
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </div>
          </template></v-data-table>
      </v-card>
    </template>

    {{ message }}
  </div>

</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    tclist: "",
    message: "",
    loading: true,
    selected_tenant: "",
    selected_user: "",
    orglist: "",
    selected_org: "",
    master_status: "",
    fetch_org_load: false,
    check_admin_load: false,
    access_controls_list: [], users_list: [], functionality_name: "",
    headers: [
      { text: "User Name", value: "username", sortable: true },
      { text: "Functionality Name", value: "functionality", sortable: true },
      { text: "Delete", value: "delete", sortable: true },

    ],
    filterArr: [],
    filters: {
      username: [],
      functionality: [],

    },
  }),
  computed: {
    bookList1() {
      return this.access_controls_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  mounted() {
    const data = {
      //uid:this.username
    };
    axios
      .post("/Admin/startCopy") //api-1
      .then(res => {
        window.console.log(res);
        if (res.data.msg == "200") {
          this.tclist = res.data.tenants;
          //this.domainpath=res.data.domainpath
        } else {
          this.message = res.data.msg;
        }
      })
      .catch(error => {
        window.console.log("error:" + error);
      });

  },

  methods: {
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.access_controls_list.map((d) => d[val]);
    },
    deleteAC(item) {
      if (!confirm("Are You Sure You Want To Delete This Access Control?")) return;
      const formData = {
        access_id: item.id,
        tenantid: this.selected_tenant,
        orgid: this.selected_org,
      };
      axios
        .post("/Admin/deleteAccessControl", formData)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Access Control deleted Successfully...!"); // show snackbar
            this.access_controls_list = res.data.access_controls_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar("#b71c1c", "Access Control not found or already deleted!"); // show snackbar
          } else if (res.data.code == "UNAUTHORIZED") {
            this.showSnackbar("#b71c1c", res.data.message); // show snackbar
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong, Please try again later!"); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          console.error(error);
        });
    },

    save() {
      const data = {
        tenantid: this.selected_tenant,
        orgid: this.selected_org,
        user_id: this.selected_user,
        functionality: this.functionality_name
      };

      axios
        .post("/Admin/saveAccessControl", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Access Control Added Successfully..."); // show snackbar on success
            this.access_controls_list = res.data.access_controls_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar("#b71c1c", "Access Control Already Present!!!"); // show snackbar on error
          } else if (res.data.code == "FORBIDDEN") {
            this.showSnackbar("#b71c1c", res.data.message); // show snackbar for forbidden access
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    fetchorganization() {
      this.fetch_org_load = true;
      const data = {
        tenantid: this.selected_tenant
      };
      axios
        .post("/Admin/fetchOrganization", data)
        .then(res => {
          window.console.log(res);
          if (res.data.msg == "200") {
            this.orglist = res.data.org;
            //this.orglist.name=res.data.org.name
            document.getElementById("orgdiv").style.display = "block";
            //this.domainpath=res.data.domainpath
          } else {
            this.message = res.data.msg;
          }
        })
        .catch(error => {
          window.console.log("error:" + error);
        })
        .finally(() => (this.fetch_org_load = false));
    },
    getUsers() {
      this.check_admin_load = true;

      const data = {
        tenantid: this.selected_tenant,
        orgid: this.selected_org
      };

      axios
        .post("/Admin/getUsers", data)
        .then(res => {
          window.console.log(res);
          if (res.data.msg == "200") {
            this.users_list = res.data.users_list
            this.access_controls_list = res.data.access_controls_list

          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbars
          }
        })
        .catch(error => {
          window.console.log("error:" + error);
        })
        .finally(() => {
          this.check_admin_load = false;
        });
    },

  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>